import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '@/types/user';

interface TeamState {
  list: IUser[];
  isLoading: boolean;
  statusFilter: number; // 0 = All, 1 = Active, 2 = Paused
  searchQuery: string;
}

const initialState: TeamState = {
  list: [],
  isLoading: false,
  statusFilter: 0,
  searchQuery: '',
};

const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    fetchTeamStart(state, action: PayloadAction<string>) {
      state.isLoading = true;
    },
    fetchTeamSuccess(state, action: PayloadAction<IUser[]>) {
      state.list = action.payload;
      state.isLoading = false;
    },
    fetchTeamFailure(state) {
      state.isLoading = false;
    },
    setStatusFilter(state, action: PayloadAction<number>) {
      state.statusFilter = action.payload;
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    updateUserStatusOptimistic(state, action: PayloadAction<{ userId: string; status: number }>) {
      const user = state.list.find(u => u.id === action.payload.userId);
      if (user) user.status = action.payload.status;
    },
    updateUserPermissionOptimistic(state, action: PayloadAction<{ userId: string; permission: string }>) {
      const user = state.list.find(u => u.id === action.payload.userId);
      if (user) user.permission = action.payload.permission;
    },
    removeUserOptimistic(state, action: PayloadAction<string>) {
      state.list = state.list.filter(u => u.id !== action.payload);
    }
  },
});

export const {
  fetchTeamStart,
  fetchTeamSuccess,
  fetchTeamFailure,
  setStatusFilter,
  setSearchQuery,
  updateUserStatusOptimistic,
  updateUserPermissionOptimistic,
  removeUserOptimistic
} = teamSlice.actions;

export default teamSlice.reducer;